import { render, staticRenderFns } from "./CaptionHost.vue?vue&type=template&id=4668790b&scoped=true&"
import script from "./CaptionHost.vue?vue&type=script&lang=js&"
export * from "./CaptionHost.vue?vue&type=script&lang=js&"
import style0 from "./CaptionHost.vue?vue&type=style&index=0&id=4668790b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668790b",
  null
  
)

export default component.exports